<div class="position-relative">
  <div [ngBusy]="{ busy: loading, message: ('common.pleaseWait' | translate) }"></div>
  <div class="embed-container" #embedContainer></div>
</div>
